import React from "react";

export const UserDB = React.createContext(null);
